module.exports = __webpack_public_path__ + "media/images/xpass/landing_page/hero-phone-7769e5d3b634721ec2ab4c5ba6f7b95a.png";